import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2Caption5 extends ITextBoxProps {}

export const TextBoxMaxLine2Caption5 = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Caption5,
  alignment = TextAligning.Left,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2Caption5): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
